<template>
	<div class="section-tel">
		<div class="section-tel-item">
			<label>咨询热线：</label>
			<p v-for="(tel, i) in data.tel" :key="tel.id" @click="callTelephone(tel)">{{ tel }}<span v-if="i < data.tel.length - 1">/</span></p>
		</div>
		<div class="section-tel-item">(点击电话可拨打)</div>
	</div>
</template>

<script>
import { Dialog } from 'vant';
export default {
	props: ['dataP'],
	data() {
		return {
			data: ''
		};
	},
	created() {
		this.data = this.dataP;
	},
	methods: {
		callTelephone(tel) {
			Dialog.confirm({
				title: '提示',
				message: `确定拨打电话：${tel} 吗？`
			})
				.then(() => {
					setTimeout(() => {
						tel = tel.replace(/\-|\s/g, '');
						window.location.href = `tel://${tel}`;
					}, 200);
				})
				.catch(() => {});
		}
	}
};
</script>

<style lang="scss" scoped>
.section-tel-item {
	height: 32px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1rem;

	label {
		font-weight: 600;
	}

	p{
		cursor: pointer;
	}

	span {
		padding: 0 4px;
		display: inline-block;
		//vertical-align: text-top;
		transform: rotate(-14deg);
	}

	// p:not(:last-child) {
	// 	margin-right: 8px;
	// }
}
</style>
